import { BoxProps } from 'grommet';
import { RightInfoCard } from './RightInfoCard';
import { RightInfoItem } from './RightInfoItem';
import { RightInfoRow } from './RightInfoRow';

export type AdditionalInformationProps = {
  background?: BoxProps['background'];
  restrictionsOnUse?: string;
  notes?: string;
};

export const AdditionalInformation = ({ background, restrictionsOnUse, notes }: AdditionalInformationProps) => {
  return (
    <RightInfoCard title="Additional Information" background={background}>
      <RightInfoRow>
        {restrictionsOnUse && <RightInfoItem title="Restrictions on Use" value={restrictionsOnUse} />}
        {notes && <RightInfoItem title="Notes" value={notes} />}
      </RightInfoRow>
    </RightInfoCard>
  );
};
